// import React, { useState, useEffect } from 'react';
// import { useNavigate, Link } from 'react-router-dom';
// import { auth, db } from '../firebase.js';
// import { signInWithEmailAndPassword } from 'firebase/auth';
// import { doc, getDoc, setDoc } from 'firebase/firestore';

// const Login = () => {
//     const navigate = useNavigate();

//     const [emailAddress, setEmailAddress] = useState('');
//     const [password, setPassword] = useState('');
//     const [error, setError] = useState('');
//     const [loading, setLoading] = useState(false);

//     // This effect will check for the presence of `shop`, `installedAt`, and access token from URL parameters
//     useEffect(() => {
//         const urlParams = new URLSearchParams(window.location.search);
//         const shop = urlParams.get('shop');
//         const installedAt = urlParams.get('installedAt');
//         const accessToken = urlParams.get('accessToken'); // Shopify access token passed in the URL (if applicable)
    
//         console.log("shop:", shop, "installedAt:", installedAt, "accessToken:", accessToken);  // Log parameters
    
//         if (shop && installedAt && accessToken) {
//             // Store the shop, installedAt, and accessToken values in localStorage
//             localStorage.setItem('shop', shop);
//             localStorage.setItem('installedAt', installedAt);
//             localStorage.setItem('accessToken', accessToken);
    
//             console.log("Stored in localStorage"); // Log when data is stored
//         }
//     }, []);
    

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         setError('');
//         setLoading(true); // Start loading
    
//         try {
//             // Sign in the user with Firebase Authentication
//             const userCredential = await signInWithEmailAndPassword(auth, emailAddress, password);
//             const user = userCredential.user;

//             // if (!user.emailVerified) {
//             //     setError('Please verify your email before logging in.');
//             //     return;
//             // }
    
//             // Fetch the user's profile from the `users` collection in Firestore
//             const userDocRef = doc(db, 'users', user.uid); // 'users' is the collection name
//             const userDocSnap = await getDoc(userDocRef);
    
//             if (userDocSnap.exists()) {
//                 const userData = userDocSnap.data();
                
//                 // Check if shop, installedAt, and accessToken are in localStorage
//                 const shop = localStorage.getItem('shop');
//                 const installedAt = localStorage.getItem('installedAt');
//                 const accessToken = localStorage.getItem('accessToken');
    
//                 // Only update these fields if they are not null or empty
//                 const updatedUserData = {
//                     ...userData, // Preserve existing data
//                     ...(shop && shop !== "null" ? { shop } : {}),
//                     ...(installedAt && installedAt !== "null" ? { installedAt } : {}),
//                     ...(accessToken && accessToken !== "null" ? { accessToken } : {}),
//                 };
    
//                 // Update the Firestore user profile with the merged data (if there are any changes)
//                 await setDoc(userDocRef, updatedUserData, { merge: true });
//                 console.log('User profile updated with Shopify data if available');
                
//                 // Navigate to the dashboard after login
//                 navigate('/dashboard');
//             } else {
//                 // If no profile exists, create the user profile and store the data
//                 const shop = localStorage.getItem('shop');
//                 const installedAt = localStorage.getItem('installedAt');
//                 const accessToken = localStorage.getItem('accessToken');
    
//                 const newUserData = {
//                     shop: shop || '',
//                     installedAt: installedAt || '',
//                     accessToken: accessToken || '',
//                     createdAt: new Date(),
//                 };
    
//                 // Set the new user data in Firestore
//                 await setDoc(userDocRef, newUserData);
//                 console.log('New user profile created with Shopify data');
                
//                 // Navigate to the dashboard after login
//                 navigate('/dashboard');
//             }
//         } catch (err) {
//             console.error('Error signing in:', err);
//             setError('Invalid email or password. Please try again.');
//         } finally {
//             setLoading(false); // Stop loading
//         }
//     };
    
//     return (
//         <div style={styles.container}>
//             <h1 style={styles.heading}>Login</h1>
//             <form onSubmit={handleSubmit} style={styles.form}>
//                 <label style={styles.label}>
//                     Email Address:
//                     <input
//                         type="email"
//                         value={emailAddress}
//                         onChange={(e) => setEmailAddress(e.target.value)}
//                         required
//                         style={styles.input}
//                     />
//                 </label>
//                 <label style={styles.label}>
//                     Password:
//                     <input
//                         type="password"
//                         value={password}
//                         onChange={(e) => setPassword(e.target.value)}
//                         required
//                         style={styles.input}
//                     />
//                 </label>
//                 <button type="submit" style={styles.button} disabled={loading}>
//                     {loading ? 'Logging in...' : 'Login'}
//                 </button>
//                 {error && <p style={styles.error}>{error}</p>}

//                 <p>
//                     Don't have an Account? <Link to='/signup' style={styles.link}>Signup</Link>
//                 </p>
//                 <p>
//                     <Link to='/login/forgetPassword' style={styles.link}>
//                         Forgot Password?
//                     </Link>
//                 </p>
//             </form>
//         </div>
//     );
// };

// const styles = {
//     container: {
//         maxWidth: '500px',
//         margin: '50px auto',
//         padding: '20px',
//         border: '1px solid #ccc',
//         borderRadius: '10px',
//         boxShadow: '0 0 10px rgba(0,0,0,0.1)',
//     },
//     heading: {
//         textAlign: 'center',
//         marginBottom: '20px',
//         color: '#000',
//     },
//     form: {
//         display: 'flex',
//         flexDirection: 'column',
//     },
//     label: {
//         marginBottom: '15px',
//         fontSize: '1em',
//     },
//     input: {
//         width: '100%',
//         padding: '10px',
//         marginTop: '5px',
//         borderRadius: '5px',
//         border: '1px solid #ccc',
//         fontSize: '1em',
//     },
//     button: {
//         padding: '10px',
//         borderRadius: '5px',
//         border: 'none',
//         backgroundColor: '#000',
//         color: 'white',
//         fontSize: '1em',
//         cursor: 'pointer',
//     },
//     error: {
//         color: 'red',
//         marginTop: '10px',
//         textAlign: 'center',
//     },
//     link: {
//         color: '#000',
//         textDecoration: 'none',
//     },
// };

// export default Login;



// import React, { useState, useEffect } from 'react';
// import { useNavigate, Link } from 'react-router-dom';
// import { auth, db } from '../firebase.js';
// import { signInWithEmailAndPassword, onAuthStateChanged } from 'firebase/auth';
// import { doc, getDoc, setDoc } from 'firebase/firestore';
// import { Checkbox } from '@mui/material';

// const Login = () => {
//     const navigate = useNavigate();

//     const [emailAddress, setEmailAddress] = useState('');
//     const [password, setPassword] = useState('');
//     const [error, setError] = useState('');
//     const [loading, setLoading] = useState(false);
//     const [rememberMe, setRememberMe] = useState(false);

//     // Check if user is already logged in
//     // useEffect(() => {
//     //     const unsubscribe = onAuthStateChanged(auth, (user) => {
//     //         if (user) {
//     //             // User is already signed in, redirect to dashboard
//     //             navigate('/dashboard');
//     //         } else {
//     //             // Try to load saved credentials if available
//     //             const savedEmail = localStorage.getItem('rememberedEmail');
//     //             if (savedEmail) {
//     //                 setEmailAddress(savedEmail);
//     //                 setRememberMe(true);
//     //             }
//     //         }
//     //     });

//     //     return () => unsubscribe();
//     // }, [navigate]);


//     // Modify your first useEffect to account for "Remember Me" preference
// useEffect(() => {
//     const unsubscribe = onAuthStateChanged(auth, (user) => {
//         if (user) {
//             // Check if the user specifically wanted to be remembered
//             const shouldRemember = localStorage.getItem('rememberedEmail') !== null;
            
//             // If user didn't choose to be remembered, sign them out
//             if (!shouldRemember) {
//                 // Don't redirect - let them log in manually
//                 return;
//             }
            
//             // Only redirect if they previously chose "Remember Me"
//             navigate('/dashboard');
//         } else {
//             // Try to load saved credentials if available
//             const savedEmail = localStorage.getItem('rememberedEmail');
//             if (savedEmail) {
//                 setEmailAddress(savedEmail);
//                 setRememberMe(true);
//             }
//         }
//     });

//     return () => unsubscribe();
// }, [navigate]);

//     // This effect will check for the presence of `shop`, `installedAt`, and access token from URL parameters
//     useEffect(() => {
//         const urlParams = new URLSearchParams(window.location.search);
//         const shop = urlParams.get('shop');
//         const installedAt = urlParams.get('installedAt');
//         const accessToken = urlParams.get('accessToken'); // Shopify access token passed in the URL (if applicable)
    
//         console.log("shop:", shop, "installedAt:", installedAt, "accessToken:", accessToken);  // Log parameters
    
//         if (shop && installedAt && accessToken) {
//             // Store the shop, installedAt, and accessToken values in localStorage
//             localStorage.setItem('shop', shop);
//             localStorage.setItem('installedAt', installedAt);
//             localStorage.setItem('accessToken', accessToken);
    
//             console.log("Stored in localStorage"); // Log when data is stored
//         }
//     }, []);
    
//     const handleRememberMe = (e) => {
//         setRememberMe(e.target.checked);
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         setError('');
//         setLoading(true); // Start loading
    
//         try {
//             // Sign in the user with Firebase Authentication
//             const userCredential = await signInWithEmailAndPassword(auth, emailAddress, password);
//             const user = userCredential.user;

//             // if (!user.emailVerified) {
//             //     setError('Please verify your email before logging in.');
//             //     return;
//             // }
    
//             // Save email in localStorage if remember me is checked
//             if (rememberMe) {
//                 localStorage.setItem('rememberedEmail', emailAddress);
//             } else {
//                 localStorage.removeItem('rememberedEmail');
//             }

//             // Fetch the user's profile from the `users` collection in Firestore
//             const userDocRef = doc(db, 'users', user.uid); // 'users' is the collection name
//             const userDocSnap = await getDoc(userDocRef);
    
//             if (userDocSnap.exists()) {
//                 const userData = userDocSnap.data();
                
//                 // Check if shop, installedAt, and accessToken are in localStorage
//                 const shop = localStorage.getItem('shop');
//                 const installedAt = localStorage.getItem('installedAt');
//                 const accessToken = localStorage.getItem('accessToken');
    
//                 // Only update these fields if they are not null or empty
//                 const updatedUserData = {
//                     ...userData, // Preserve existing data
//                     ...(shop && shop !== "null" ? { shop } : {}),
//                     ...(installedAt && installedAt !== "null" ? { installedAt } : {}),
//                     ...(accessToken && accessToken !== "null" ? { accessToken } : {}),
//                 };
    
//                 // Update the Firestore user profile with the merged data (if there are any changes)
//                 await setDoc(userDocRef, updatedUserData, { merge: true });
//                 console.log('User profile updated with Shopify data if available');
                
//                 // Navigate to the dashboard after login
//                 navigate('/dashboard');
//             } else {
//                 // If no profile exists, create the user profile and store the data
//                 const shop = localStorage.getItem('shop');
//                 const installedAt = localStorage.getItem('installedAt');
//                 const accessToken = localStorage.getItem('accessToken');
    
//                 const newUserData = {
//                     shop: shop || '',
//                     installedAt: installedAt || '',
//                     accessToken: accessToken || '',
//                     createdAt: new Date(),
//                 };
    
//                 // Set the new user data in Firestore
//                 await setDoc(userDocRef, newUserData);
//                 console.log('New user profile created with Shopify data');
                
//                 // Navigate to the dashboard after login
//                 navigate('/dashboard');
//             }
//         } catch (err) {
//             console.error('Error signing in:', err);
//             setError('Invalid email or password. Please try again.');
//         } finally {
//             setLoading(false); // Stop loading
//         }
//     };
    
//     return (
//         <div style={styles.container}>
//             <h1 style={styles.heading}>Login</h1>
//             <form onSubmit={handleSubmit} style={styles.form}>
//                 <label style={styles.label}>
//                     Email Address:
//                     <input
//                         type="email"
//                         value={emailAddress}
//                         onChange={(e) => setEmailAddress(e.target.value)}
//                         required
//                         style={styles.input}
//                     />
//                 </label>
//                 <label style={styles.label}>
//                     Password:
//                     <input
//                         type="password"
//                         value={password}
//                         onChange={(e) => setPassword(e.target.value)}
//                         required
//                         style={styles.input}
//                     />
//                 </label>

    

//                            <label style={styles.checkboxLabel}>
//                                         <Checkbox
//                                             checked={rememberMe}
//                                             onChange={handleRememberMe}
                              
//                                         />
//                                       Remember Me
                                       
//                                     </label>
              
//                 <button type="submit" style={styles.button} disabled={loading}>
//                     {loading ? 'Logging in...' : 'Login'}
//                 </button>
//                 {error && <p style={styles.error}>{error}</p>}

//                 <p>
//                     Don't have an Account? <Link to='/signup' style={styles.link}>Signup</Link>
//                 </p>
//                 <p>
//                     <Link to='/login/forgetPassword' style={styles.link}>
//                         Forgot Password?
//                     </Link>
//                 </p>
//             </form>
//         </div>
//     );
// };

// const styles = {
//     container: {
//         maxWidth: '500px',
//         margin: '50px auto',
//         padding: '20px',
//         border: '1px solid #ccc',
//         borderRadius: '10px',
//         boxShadow: '0 0 10px rgba(0,0,0,0.1)',
//     },
//     heading: {
//         textAlign: 'center',
//         marginBottom: '20px',
//         color: '#000',
//     },
//     form: {
//         display: 'flex',
//         flexDirection: 'column',
//     },
//     label: {
//         marginBottom: '15px',
//         fontSize: '1em',
//     },
//     input: {
//         width: '100%',
//         padding: '10px',
//         marginTop: '5px',
//         borderRadius: '5px',
//         border: '1px solid #ccc',
//         fontSize: '1em',
//     },
//     rememberMeContainer: {
//         marginBottom: '15px',
//     },
//     checkboxLabel: {
//         display: 'flex',
//         alignItems: 'center',
//         fontSize: '0.9em',
//         cursor: 'pointer',
//     },
//     checkbox: {
//         marginRight: '8px',
//         cursor: 'pointer',
//     },
//     button: {
//         padding: '10px',
//         borderRadius: '5px',
//         border: 'none',
//         backgroundColor: '#000',
//         color: 'white',
//         fontSize: '1em',
//         cursor: 'pointer',
//     },
//     error: {
//         color: 'red',
//         marginTop: '10px',
//         textAlign: 'center',
//     },
//     link: {
//         color: '#000',
//         textDecoration: 'none',
//     },
// };

// export default Login;





// import React, { useState, useEffect } from 'react';
// import { useNavigate, Link } from 'react-router-dom';
// import { auth, db } from '../firebase.js';
// import { signInWithEmailAndPassword, onAuthStateChanged } from 'firebase/auth';
// import { doc, getDoc, setDoc } from 'firebase/firestore';
// import { Checkbox } from '@mui/material';

// const Login = () => {
//     const navigate = useNavigate();

//     const [emailAddress, setEmailAddress] = useState('');
//     const [password, setPassword] = useState('');
//     const [error, setError] = useState('');
//     const [loading, setLoading] = useState(false);
//     const [rememberMe, setRememberMe] = useState(false);
//     const [isShopifyInstall, setIsShopifyInstall] = useState(false);

//     // Check for Shopify installation parameters
//     useEffect(() => {
//         const urlParams = new URLSearchParams(window.location.search);
//         const shop = urlParams.get('shop');
//         const installedAt = urlParams.get('installedAt');
//         const accessToken = urlParams.get('accessToken');
    
//         console.log("shop:", shop, "installedAt:", installedAt, "accessToken:", accessToken);
    
//         // Check if this is a Shopify installation flow
//         if (shop || installedAt || accessToken) {
//             setIsShopifyInstall(true);
            
//             // Store the shop, installedAt, and accessToken values in localStorage
//             if (shop && shop !== "null") localStorage.setItem('shop', shop);
//             if (installedAt && installedAt !== "null") localStorage.setItem('installedAt', installedAt);
//             if (accessToken && accessToken !== "null") localStorage.setItem('accessToken', accessToken);
    
//             console.log("Stored Shopify data in localStorage");
//         } else {
//             setIsShopifyInstall(false);
//         }
//     }, []);

//     // Handle authentication state and remember me functionality
//     useEffect(() => {
//         const unsubscribe = onAuthStateChanged(auth, async (user) => {
//             if (user) {
//                 // Check if this is an existing user by looking at their Firestore profile
//                 try {
//                     const userDocRef = doc(db, 'users', user.uid);
//                     const userDocSnap = await getDoc(userDocRef);
                    
//                     let isExistingUser = false;
//                     if (userDocSnap.exists()) {
//                         const userData = userDocSnap.data();
//                         // Consider user as existing if they have profile data (created before verification feature)
//                         isExistingUser = userData.brandName || userData.phoneNumber || userData.address;
//                     }

//                     // Only check email verification for new users (not existing ones)
//                     if (!isExistingUser && !user.emailVerified) {
//                         setError('Please verify your email before logging in.');
//                         return;
//                     }

//                     // If this is a Shopify installation, don't auto-redirect
//                     // Force user to login manually to ensure proper data linking
//                     if (isShopifyInstall) {
//                         console.log("Shopify installation detected - showing login form");
//                         return;
//                     }
                    
//                     // Check if the user specifically wanted to be remembered
//                     const shouldRemember = localStorage.getItem('rememberedEmail') !== null;
                    
//                     // Only auto-redirect if they previously chose "Remember Me" and it's not a Shopify install
//                     if (shouldRemember) {
//                         console.log("Auto-redirecting remembered user to dashboard");
//                         navigate('/dashboard');
//                     }
//                 } catch (error) {
//                     console.error('Error checking user profile:', error);
//                     // If there's an error, proceed without verification check for safety
//                 }
//             } else {
//                 // Try to load saved credentials if available and not a Shopify install
//                 if (!isShopifyInstall) {
//                     const savedEmail = localStorage.getItem('rememberedEmail');
//                     if (savedEmail) {
//                         setEmailAddress(savedEmail);
//                         setRememberMe(true);
//                     }
//                 }
//             }
//         });

//         return () => unsubscribe();
//     }, [navigate, isShopifyInstall]);

//     const handleRememberMe = (e) => {
//         setRememberMe(e.target.checked);
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         setError('');
//         setLoading(true);
    
//         try {
//             // Sign in the user with Firebase Authentication
//             const userCredential = await signInWithEmailAndPassword(auth, emailAddress, password);
//             const user = userCredential.user;

//             // Check if this is an existing user by looking at their Firestore profile
//             const userDocRef = doc(db, 'users', user.uid);
//             const userDocSnap = await getDoc(userDocRef);
            
//             let isExistingUser = false;
//             if (userDocSnap.exists()) {
//                 const userData = userDocSnap.data();
//                 // Consider user as existing if they have profile data (created before verification feature)
//                 isExistingUser = userData.brandName || userData.phoneNumber || userData.address;
//             }

//             // Only check email verification for new users (not existing ones)
//             if (!isExistingUser && !user.emailVerified) {
//                 setError('Please verify your email before logging in.');
//                 setLoading(false);
//                 return;
//             }
    
//             // Save email in localStorage if remember me is checked (but not during Shopify install)
//             if (rememberMe && !isShopifyInstall) {
//                 localStorage.setItem('rememberedEmail', emailAddress);
//             } else if (!rememberMe) {
//                 localStorage.removeItem('rememberedEmail');
//             }

//             // Continue with existing user profile logic
//             if (userDocSnap.exists()) {
//                 const userData = userDocSnap.data();
                
//                 // Check if shop, installedAt, and accessToken are in localStorage
//                 const shop = localStorage.getItem('shop');
//                 const installedAt = localStorage.getItem('installedAt');
//                 const accessToken = localStorage.getItem('accessToken');
    
//                 // Prepare updated data
//                 const updatedUserData = { ...userData };
                
//                 // Only update Shopify fields if they exist and are not null
//                 if (shop && shop !== "null") updatedUserData.shop = shop;
//                 if (installedAt && installedAt !== "null") updatedUserData.installedAt = installedAt;
//                 if (accessToken && accessToken !== "null") updatedUserData.accessToken = accessToken;
    
//                 // Update the Firestore user profile with the merged data
//                 await setDoc(userDocRef, updatedUserData, { merge: true });
//                 console.log('User profile updated with Shopify data if available');
                
//                 // Clear Shopify data from localStorage after successful linking
//                 if (isShopifyInstall) {
//                     localStorage.removeItem('shop');
//                     localStorage.removeItem('installedAt');
//                     localStorage.removeItem('accessToken');
//                 }
                
//             } else {
//                 // If no profile exists, this shouldn't happen for existing users
//                 // But handle it just in case
//                 console.warn('User profile not found in Firestore');
//                 setError('User profile not found. Please contact support.');
//                 setLoading(false);
//                 return;
//             }

//             // Navigate to the dashboard after successful login
//             navigate('/dashboard');

//         } catch (err) {
//             console.error('Error signing in:', err);
            
//             if (err.code === 'auth/user-not-found') {
//                 setError('No account found with this email. Please sign up first.');
//             } else if (err.code === 'auth/wrong-password') {
//                 setError('Incorrect password. Please try again.');
//             } else if (err.code === 'auth/invalid-email') {
//                 setError('Please enter a valid email address.');
//             } else if (err.code === 'auth/too-many-requests') {
//                 setError('Too many failed attempts. Please try again later.');
//             } else {
//                 setError('Invalid email or password. Please try again.');
//             }
//         } finally {
//             setLoading(false);
//         }
//     };
    
//     return (
//         <div style={styles.container}>
//             {isShopifyInstall && (
//                 <div style={styles.shopifyNotice}>
//                     <p style={styles.shopifyText}>
//                         🛍️ Complete your Shopify app installation by logging in or creating an account
//                     </p>
//                 </div>
//             )}
            
//             <h1 style={styles.heading}>Login</h1>
//             <form onSubmit={handleSubmit} style={styles.form}>
//                 <label style={styles.label}>
//                     Email Address:
//                     <input
//                         type="email"
//                         value={emailAddress}
//                         onChange={(e) => setEmailAddress(e.target.value)}
//                         required
//                         style={styles.input}
//                         disabled={loading}
//                     />
//                 </label>
//                 <label style={styles.label}>
//                     Password:
//                     <input
//                         type="password"
//                         value={password}
//                         onChange={(e) => setPassword(e.target.value)}
//                         required
//                         style={styles.input}
//                         disabled={loading}
//                     />
//                 </label>

//                 {/* Only show Remember Me if not a Shopify installation */}
//                 {!isShopifyInstall && (
//                     <label style={styles.checkboxLabel}>
//                         <Checkbox
//                             checked={rememberMe}
//                             onChange={handleRememberMe}
//                             disabled={loading}
//                         />
//                         Remember Me
//                     </label>
//                 )}
              
//                 <button 
//                     type="submit" 
//                     style={{
//                         ...styles.button,
//                         opacity: loading ? 0.6 : 1,
//                         cursor: loading ? 'not-allowed' : 'pointer'
//                     }} 
//                     disabled={loading}
//                 >
//                     {loading ? 'Logging in...' : 'Login'}
//                 </button>
                
//                 {error && <p style={styles.error}>{error}</p>}

//                 <p style={styles.text}>
//                     Don't have an Account? <Link to='/signup' style={styles.link}>Signup</Link>
//                 </p>
//                 <p style={styles.text}>
//                     <Link to='/login/forgetPassword' style={styles.link}>
//                         Forgot Password?
//                     </Link>
//                 </p>
//             </form>
//         </div>
//     );
// };

// const styles = {
//     container: {
//         maxWidth: '500px',
//         margin: '50px auto',
//         padding: '20px',
//         border: '1px solid #ccc',
//         borderRadius: '10px',
//         boxShadow: '0 0 10px rgba(0,0,0,0.1)',
//     },
//     heading: {
//         textAlign: 'center',
//         marginBottom: '20px',
//         color: '#000',
//     },
//     form: {
//         display: 'flex',
//         flexDirection: 'column',
//     },
//     label: {
//         marginBottom: '15px',
//         fontSize: '1em',
//     },
//     input: {
//         width: '100%',
//         padding: '10px',
//         marginTop: '5px',
//         borderRadius: '5px',
//         border: '1px solid #ccc',
//         fontSize: '1em',
//     },
//     checkboxLabel: {
//         display: 'flex',
//         alignItems: 'center',
//         fontSize: '0.9em',
//         cursor: 'pointer',
//         marginBottom: '15px',
//     },
//     button: {
//         padding: '10px',
//         borderRadius: '5px',
//         border: 'none',
//         backgroundColor: '#000',
//         color: 'white',
//         fontSize: '1em',
//         cursor: 'pointer',
//         marginBottom: '15px',
//     },
//     error: {
//         color: 'red',
//         marginTop: '10px',
//         textAlign: 'center',
//     },
//     text: {
//         textAlign: 'center',
//         marginTop: '10px',
//     },
//     link: {
//         color: '#000',
//         textDecoration: 'none',
//     },
//     shopifyNotice: {
//         backgroundColor: '#f0f8ff',
//         border: '1px solid #0066cc',
//         borderRadius: '5px',
//         padding: '15px',
//         marginBottom: '20px',
//     },
//     shopifyText: {
//         color: '#0066cc',
//         textAlign: 'center',
//         margin: 0,
//         fontSize: '0.9em',
//     },
// };

// export default Login;


import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { auth, db } from '../firebase.js';
import { signInWithEmailAndPassword, onAuthStateChanged } from 'firebase/auth';
import { doc, getDoc, setDoc } from 'firebase/firestore';


const Login = () => {
    const navigate = useNavigate();

    const [emailAddress, setEmailAddress] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [rememberMe, setRememberMe] = useState(false);
    const [isShopifyInstall, setIsShopifyInstall] = useState(false);
    const [customImage, setCustomImage] = useState(null);

    // Check for Shopify installation parameters
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const shop = urlParams.get('shop');
        const installedAt = urlParams.get('installedAt');
        const accessToken = urlParams.get('accessToken');
    
        console.log("shop:", shop, "installedAt:", installedAt, "accessToken:", accessToken);
    
        // Check if this is a Shopify installation flow
        if (shop || installedAt || accessToken) {
            setIsShopifyInstall(true);
            
            // Store the shop, installedAt, and accessToken values in localStorage
            if (shop && shop !== "null") localStorage.setItem('shop', shop);
            if (installedAt && installedAt !== "null") localStorage.setItem('installedAt', installedAt);
            if (accessToken && accessToken !== "null") localStorage.setItem('accessToken', accessToken);
    
            console.log("Stored Shopify data in localStorage");
        } else {
            setIsShopifyInstall(false);
        }
    }, []);

    // Handle authentication state and remember me functionality
    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, async (user) => {
            if (user) {
                // If this is a Shopify installation, don't auto-redirect
                // Force user to login manually to ensure proper data linking
                if (isShopifyInstall) {
                    console.log("Shopify installation detected - showing login form");
                    return;
                }
                
                // Check if the user specifically wanted to be remembered
                const shouldRemember = localStorage.getItem('rememberedEmail');

                console.log("the remembered email is " , shouldRemember);
                
                // Only auto-redirect if they previously chose "Remember Me" and it's not a Shopify install
                if (shouldRemember) {
                    console.log("Auto-redirecting remembered user to dashboard");
                    navigate('/dashboard');
                }
            } else {
                // Try to load saved credentials if available and not a Shopify install
                if (!isShopifyInstall) {
                    const savedEmail = localStorage.getItem('rememberedEmail');
                    if (savedEmail) {
                        setEmailAddress(savedEmail);
                        setRememberMe(true);
                    }
                }
            }
        });

        return () => unsubscribe();
    }, [navigate, isShopifyInstall]);

    const handleRememberMe = (e) => {
        setRememberMe(e.target.checked);
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);
    
        try {
            // Sign in the user with Firebase Authentication
            const userCredential = await signInWithEmailAndPassword(auth, emailAddress, password);
            const user = userCredential.user;
    
            // Save email in localStorage if remember me is checked (but not during Shopify install)
            if (rememberMe && !isShopifyInstall) {
                localStorage.setItem('rememberedEmail', emailAddress);
            } else if (!rememberMe) {
                localStorage.removeItem('rememberedEmail');
            }

            // Continue with existing user profile logic
            const userDocRef = doc(db, 'users', user.uid);
            const userDocSnap = await getDoc(userDocRef);
            
            if (userDocSnap.exists()) {
                const userData = userDocSnap.data();
                
                // Check if shop, installedAt, and accessToken are in localStorage
                const shop = localStorage.getItem('shop');
                const installedAt = localStorage.getItem('installedAt');
                const accessToken = localStorage.getItem('accessToken');
    
                // Prepare updated data
                const updatedUserData = { ...userData };
                
                // Only update Shopify fields if they exist and are not null
                if (shop && shop !== "null") updatedUserData.shop = shop;
                if (installedAt && installedAt !== "null") updatedUserData.installedAt = installedAt;
                if (accessToken && accessToken !== "null") updatedUserData.accessToken = accessToken;
    
                // Update the Firestore user profile with the merged data
                await setDoc(userDocRef, updatedUserData, { merge: true });
                console.log('User profile updated with Shopify data if available');
                
                // Clear Shopify data from localStorage after successful linking
                if (isShopifyInstall) {
                    localStorage.removeItem('shop');
                    localStorage.removeItem('installedAt');
                    localStorage.removeItem('accessToken');
                }
                
            } else {
                // If no profile exists, this shouldn't happen for existing users
                // But handle it just in case
                console.warn('User profile not found in Firestore');
                setError('User profile not found. Please contact support.');
                setLoading(false);
                return;
            }

            // Navigate to the dashboard after successful login
            navigate('/dashboard');

        } catch (err) {
            console.error('Error signing in:', err);
            
            if (err.code === 'auth/user-not-found') {
                setError('No account found with this email. Please sign up first.');
            } else if (err.code === 'auth/wrong-password') {
                setError('Incorrect password. Please try again.');
            } else if (err.code === 'auth/invalid-email') {
                setError('Please enter a valid email address.');
            } else if (err.code === 'auth/too-many-requests') {
                setError('Too many failed attempts. Please try again later.');
            } else {
                setError('Invalid email or password. Please try again.');
            }
        } finally {
            setLoading(false);
        }
    };
    
    return (
        <div className="min-h-screen flex md:mx-24 mx-4">
 
<div className="hidden lg:flex lg:w-7/12 items-center justify-center h-screen overflow-hidden">
    <div className="w-full h-full flex justify-center items-center">
        <img 
            src="/illustration_unitee.png" 
            alt="" 
            className="object-contain max-w-full max-h-full"
        />
    </div>
</div>



            <div className="w-full lg:w-5/12 flex items-center justify-left p-2 bg-white">
                <div className="mx-2 w-full space-y-8 md:mr-20">
                    {/* Header */}
                    <div className="text-right">
                        <p className="text-sm text-gray-600">
                            Don't have an account? 
                            <Link to="/signup" className="font-medium text-blue-600 hover:text-blue-500 ml-1">
                                Sign up
                            </Link>
                        </p>
                    </div>

                    {/* Shopify Notice */}
                    {isShopifyInstall && (
                        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                            <p className="text-blue-800 text-sm text-center">
                                🛍️ Complete your Shopify app installation by logging in or creating an account
                            </p>
                        </div>
                    )}

                    {/* Login Title */}
                    <div>
                        <h2 className="text-3xl font-bold text-gray-900">Login</h2>
                       
                    </div>

                    <div className="grid grid-cols-2 gap-3">
                        <button className="w-full inline-flex justify-center py-2 px-4 border border-gray-300 rounded-md shadow-sm bg-white text-sm font-medium text-gray-500 hover:bg-gray-50 transition-colors cursor-not-allowed opacity-50">
                            <svg className="w-5 h-5 mr-2" viewBox="0 0 24 24">
                                <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                                <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                                <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                                <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
                            </svg>
                            Google
                        </button>
                        <button className="w-full inline-flex justify-center py-2 px-4 border border-gray-300 rounded-md shadow-sm bg-white text-sm font-medium text-gray-500 hover:bg-gray-50 transition-colors cursor-not-allowed opacity-50">
                            <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 24 24">
                                <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
                            </svg>
                            Apple ID
                        </button>
                    </div>

                    <div className="relative">
                        <div className="absolute inset-0 flex items-center">
                            <div className="w-full border-t border-gray-300" />
                        </div>
                        <div className="relative flex justify-center text-sm">
                            <span className="px-2 bg-white text-gray-500">Or continue with email address</span>
                        </div>
                    </div>

                    {/* Login Form */}
                    <form className="space-y-2" onSubmit={handleSubmit}>
                        <div>
                            <input
                                type="email"
                                value={emailAddress}
                                onChange={(e) => setEmailAddress(e.target.value)}
                                required
                                disabled={loading}
                                className="w-full px-3 py-3 border border-gray-600 rounded-md placeholder-gray-900 text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                                placeholder="Email address"
                            />
                        </div>

                        <div>
                            <input
                                type="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                                disabled={loading}
                                className="w-full px-3 py-3 border border-gray-600 rounded-md placeholder-gray-900 text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                                placeholder="Password"
                            />
                        </div>

                        {/* Remember Me - Only show if not Shopify installation */}
                        {!isShopifyInstall && (
                            <div className="flex items-center">
                                <input
                                    id="remember-me"
                                    name="remember-me"
                                    type="checkbox"
                                    checked={rememberMe}
                                    onChange={handleRememberMe}
                                    disabled={loading}
                                    className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                                />
                                <label htmlFor="remember-me" className="ml-2 block text-sm text-gray-900">
                                    Remember me
                                </label>
                            </div>
                        )}

                        <div>
                            <button
                                type="submit"
                                disabled={loading}
                                className={`w-full flex justify-center py-3 px-4 border border-transparent rounded-full shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all ${
                                    loading ? 'opacity-50 cursor-not-allowed' : ''
                                }`}
                            >
                                {loading ? 'Logging in...' : 'Login'}
                            </button>
                        </div>

                        {error && (
                            <div className="text-red-600 text-sm text-center bg-red-50 border border-red-200 rounded-md p-3">
                                {error}
                            </div>
                        )}

                        <div className="text-center">
                            <Link 
                                to="/login/forgetPassword" 
                                className="text-sm text-blue-600 hover:text-blue-500 font-medium"
                            >
                                Forgot Password?
                            </Link>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default Login;